import GlareEffect from './GlareEffect';
import GlowEffect from './GlowEffect';
import HologramEffect from './HologramEffect';
import LightEffect from './LightEffect';
import SpriteImageEffect from './SpriteImageEffect';
import TextEffect from './TextEffect';

/**
 * [디지털 카드 효과 컴포넌트]
 *
 * @description
 * 디지털 카드의 효과를 정의하는 컴포넌트입니다.
 *
 * @features
 * - 라이트 효과
 * ```tsx
 * <DigitalCardEffect.Light />
 * ```
 * - 글레어 효과
 * ```tsx
 * <DigitalCardEffect.Glare />
 * ```
 * - 홀로그램 효과
 * ```tsx
 * <DigitalCardEffect.Hologram />
 * ```
 * - 텍스트 효과
 * ```tsx
 * <DigitalCardEffect.Text />
 * ```
 * - 스프라이트 이미지 효과
 * ```tsx
 * <DigitalCardEffect.SpriteImage />
 * ```
 *
 * @see {@link LightEffect} 라이트 효과
 * @see {@link GlareEffect} 글레어 효과
 * @see {@link HologramEffect} 홀로그램 효과
 * @see {@link TextEffect} 텍스트 효과
 * @see {@link SpriteImageEffect} 스프라이트 이미지 효과
 */
const DigitalCardEffect = {
  Light: LightEffect,
  Glare: GlareEffect,
  Glow: GlowEffect,
  Hologram: HologramEffect,
  Text: TextEffect,
  SpriteImage: SpriteImageEffect,
} as const;

export default DigitalCardEffect;
